const NoStocksMessage = () => {
  return (
    <div className="text-center">
      <p className="text-muted lead">Depoda ürün bulunmamaktadır.</p>
    </div>
  );
};

export default NoStocksMessage;
